import { createBusinessLogger } from '@/utils/logger/businessLogger';
/**
 * 埋点事件
 */
export const HOME_EVENT_NAMES = {
  // ---------------- 接口相关错误事件 ---------------- //
  CMS_INIT_ERROR: 'cms_init_error',
  CMS_PARAMS_ERROR: 'cms_params_error',
  CMS_NO_FLOOR: 'cms_no_floor',
  CMS_QUERY_FEEDS_ERROR: 'cms_query_feeds_error',
  // ---------------- 小首页相关错误事件 ---------------- //
  MINIHOME_NO_DATA: 'minihome_no_data',
  MINIHOME_DUPLICATE_LINK: 'minihome_duplicate_link',
  // ---------------- 模块相关错误事件 ---------------- //
  BEST_SELLER_NO_DATA: 'best_seller_no_data',
  FLASH_SALES_NO_DATA: 'flash_sales_no_data',
  // ---------------- 通用事件 ---------------- //
  LINK_PARSING_ERROR: 'link_parsing_error',
  DOMAIN_DOESNT_MATCH: 'domain_doesnt_match',
} as const;

/**
 * 埋点主类型（区分API异常或JS异常等）
 */
export enum HOME_TRACK_TYPE {
  CMS_API_ERROR = 'CMS_API_ERROR',
  CMS_JS_ERROR = 'CMS_JS_ERROR',
  CMS_CLICK_ERROR = 'CMS_CLICK_ERROR',
}

// 导出类型定义，既可以当常量用也可以当类型用
export type HomeEventNames = typeof HOME_EVENT_NAMES;

// 暂时不需要分类，之后有需要再添加
const categoryNames: string[] = ['type'];
// Business Logger 实例 - 售后
export const homeBusinessLogger = createBusinessLogger<HomeEventNames>('home', categoryNames);
